import React, { useState, useEffect, useRef, useLayoutEffect } from "react";

/** Components */
import { Grid, ButtonGroup, TextField, TableRow, TableCell, TableHead, TableBody, Table, TableContainer, Button, Dialog, Autocomplete, Checkbox, Paper } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import InvoicePreview from "./invPreview";
import FileInput from "../../commons/FileInput.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
/** Icons */

/** Api & Function */
import {
  getAircraft,
  postConversion,
  getCustomers,
  getFlight,
  getInventory,
  getVehicle,
  getProductUnit,
  createAirInv,
  getInvoiceForm,
  checkPrice,
  replaceAirInv,
  getAcsreg,
  checkSaleOrder,
  getProduct,
} from "../../../services/api";
import { sumOfField } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useSnackbar } from "notistack";
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { saleFormConfig } from "../../config";

const initialProduct = {
  vehicle: null,
  // refueler_no: null,
  hydrant_sys: "", //nhap
  position_no: "", //nhap
  driver: "", //nhap
  cert_no: "", //nhap
  meter_before_pump: "", //nhap
  meter_after_pump: "", //nhap
  product_id: null,
  product_name: null,
  productunit_id: null,
  product_unit: null,
  unit: null,
  density: "", //nhap
  temp: "", //nhap
  d15: "",
  vcf: "",
  wcf: "",
  l15: "",
  kg: "",
  lit: "",
  gallon: "",
  quantity: null,
  price_unit: null,
  amount: null,
  price_id: null,
  // vehicle_id: null,
  price_no: null,
};
const initialInput = {
  flight: null,
  inventory: null,
  flt: null,
  customer: null,
  date: moment(Date.now()).format("YYYY-MM-DD"),
  aircraft: null,
  acsreg: null,
  start_date: "",
  end_date: "",
  note: "",
  invoiceproducts: [initialProduct],
  method: 1,
  product: null,
  cert_no: "",
  driver: "",
  loadsample: "",
  maxflow: "",
  diffpres: "",
  nozzlepres: "",
  form: null,
  saletype: 3,
  loadingtype: 1,
  sourcing: 1,
  saleorder: null,
  airline_name: "",
  airline: null,
  checkbox_nhap_tay_flight: false,
  checkbox_nhap_tay_acsreg: false,
};
const CreateInvoice = () => {
  // hook
  const [t] = useTranslation();
  const user = useSelector((state) => state.user.data);
  const location = useLocation();
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  // state
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [input, setInput] = useState({ ...initialInput });
  const [price, setPrice] = useState(null);
  const shipped_to = input.saleorder && JSON.parse(input.saleorder.shipped_to);
  const isReplace = Boolean(location.state?.id);
  const dataForPreview = {
    serial: input.form,
    valid_date: input.date,
    selectedCustomer: { ...input.customer, name: `${input.customer?.name} ${input.airline_name ? " / " + input.airline_name : ""}` },
    note: input.note,
    invoiceproducts: input.invoiceproducts.map((item) => ({
      ...item,
      density: item.density / 10000,
      quantity: price?.unit_code === "USG" ? item.gallon : item.lit,
      amount: (price?.unit_code === "USG" ? item.gallon : item.lit) * price?.price_without_tax,
    })),
    amount: (price?.unit_code === "USG" ? input.invoiceproducts[0].gallon : input.invoiceproducts[0].lit) * price?.price_without_tax,
    product_name: price?.product_name,
    product_unit: price?.unit_code,
    price_unit: price?.price_without_tax,
    sub_total: price?.price_without_tax * (price?.unit_code === "USG" ? sumOfField(input.invoiceproducts, "gallon") : sumOfField(input.invoiceproducts, "lit")),
    vat_rate: price?.vat_rate,
    total: (price?.vat_rate / 100 + 1) * price?.price_without_tax * sumOfField(input.invoiceproducts, price?.unit_code === "USG" ? "gallon" : "lit"),
    priceData: price,
    aircraft_no: input.acsreg?.code,
    flight_no: input.flight?.flight_no,
    route: input.flight?.route,
    hydrant_sys: input.inventory?.whtype == "2" ? "Xe tra nạp" : input.inventory?.whtype == "3" ? "Tra nạp ngầm" : "",
  };
  // method
  const handleSubmit = async () => {
    const data = {
      valid_date: input.date,
      start_pump: moment(input.start_date).format("YYYY-MM-DD HH:mm"),
      end_pump: moment(input.end_date).format("YYYY-MM-DD HH:mm"),
      code_aircraft: input.acsreg?.code,
      acsreg_id: input.acsreg?.id,
      flight_id: input.flight?.id,
      flight_no: input.flight?.flight_no,
      route: input.flight?.route,
      aircraft_id: input.aircraft?.id,
      aircraft_type: input.aircraft?.code,

      customer_id: input.customer?.id,
      customer_name: input.customer?.name,
      customer_tax: input.customer?.tax_code,
      customer_address: input.customer?.address,
      inventory_id: input.inventory?.id,
      hydrant_sys: input.inventory?.whtype,
      vehicle_id: input.invoiceproducts[0].vehicle?.id,
      position_no: input.inventory?.whtype == 3 ? input.invoiceproducts[0].position_no : undefined, // vi tri tra nap
      refueler_no: input.invoiceproducts[0].vehicle?.license_plate,

      cert_no: input.cert_no,
      meter_before_pump: input.invoiceproducts[0].meter_before_pump,
      meter_after_pump: input.invoiceproducts[0].meter_after_pump,
      density: (input.invoiceproducts[0].density / 10000).toFixed(4),
      temp: input.invoiceproducts[0].temp,
      d15: input.invoiceproducts[0].d15,
      vcf: input.invoiceproducts[0].vcf,
      wcf: input.invoiceproducts[0].wcf,
      l15: input.invoiceproducts[0].l15,
      kg: input.invoiceproducts[0].kg,
      lit: input.invoiceproducts[0].lit,
      gallon: input.invoiceproducts[0].gallon,
      quantity: price.unit_id === 21 ? input.invoiceproducts[0].lit : input.invoiceproducts[0].gallon,

      product_name: price?.product_name,
      product_id: price?.product_id,
      productunit_code: price?.unit_code,
      productunit_id: price?.unit_id,
      note: input.note,
      driver: input.driver,

      loadsample: input.invoiceproducts[0].meter_after_pump - input.invoiceproducts[0].meter_before_pump,
      maxflow: input.maxflow === "" ? null : input.maxflow,
      diffpres: input.diffpres === "" ? null : input.diffpres,
      nozzlepres: input.nozzlepres === "" ? null : input.nozzlepres,
      formno: input.form?.form,
      serial: input.form?.series,
      invoiceform_id: input.form?.id,
      caltype: input.method,
      saleorder_id:
        input.saleorder?.loading_info &&
        JSON.parse(input.saleorder.loading_info).find(
          (item) => item.saleType === input.saletype && item.loadingTypes === input.loadingtype && (item.company === -1 || item.company === user.organization_id)
        )?.id_loadingInfo,
      saleorderpr_id: input.saleorder?.id,
      saletype_id: input.saletype,
      loadingtype_id: input.loadingtype,
      airline_id: input.airline?.id,
      airline_name: input.airline_name,
      price_id: price?.id,
      sourcing: input.sourcing,
    };
    const promise =
      input.image &&
      new Promise((res, rej) => {
        const fr = new FileReader();
        fr.readAsDataURL(input.image);
        fr.onload = () => {
          data.pre_ft = fr.result;
          res();
        };
      });
    if (input.image) await promise;
    return location.state ? replaceAirInv(location.state.id, data) : createAirInv(data);
  };
  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/invoices/${res.data?.id}?type=NAPR`);
  };
  // effect
  useEffect(() => {
    if (!location.state) return;
    setInput((prev) => ({
      ...prev,
      airline_name: location.state.airline_name || "",
      checkbox_nhap_tay_flight: Boolean(!location.state.flight_id && location.state.flight_no),
      checkbox_nhap_tay_acsreg: Boolean(!location.state.acsreg_id && location.state.code_aircraft),
      flight: { flight_no: location.state.flight_no, route: location.state.route },
      acsreg: { code: location.state.code_aircraft },
      driver: location.state.invoiceproducts[0].driver,
      method: location.state.caltype,
      cert_no: location.state.invoiceproducts[0].cert_no,
      loadsample: location.state.loadsample,
      maxflow: location.state.maxflow,
      diffpres: location.state.diffpres,
      nozzlepres: location.state.nozzlepres,
      note: location.state.note || "",
      start_date: moment(location.state.start_pump).format("YYYY-MM-DD[T]HH:mm"),
      end_date: moment(location.state.end_pump).format("YYYY-MM-DD[T]HH:mm"),
      date: moment(location.state.valid_date).format("YYYY-MM-DD"),
      invoiceproducts: location.state.invoiceproducts.map((item) => ({ ...item, density: Math.round(item.density * 10000) })),
    }));
  }, [location.state]);
  useLayoutEffect(() => {
    setPrice(null);
    if (!input.date || !input.inventory || !input.customer) return;
    checkPrice({
      valid_date: input.date,
      customer_id: input.customer?.id,
      airline_id: input.airline?.id || undefined, // optional
      saletype_id: input.saletype,
      inventory_id: input.inventory.id,
    }).then((res) => {
      if (res.code === 200) {
        setPrice(res.data);
        if (!res.data) enqueueSnackbar("Hệ thống chưa khai báo giá bán hàng", { variant: "warning" });
      } else enqueueSnackbar(res.message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.date, input.inventory, input.customer, input.airline, input.saletype]);

  useEffect(() => {
    dispatch(setHeaderTitle(location.state ? "PHÁT HÀNH THAY THẾ HOÁ ĐƠN BÁN HÀNG TẠI SÂN BAY" : "TẠO HOÁ ĐƠN BÁN HÀNG TẠI SÂN BAY"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper styles={{ margin: 5, marginTop: 20 }}>
      <Grid container spacing={2} sx={{ marginTop: 1, width: "98%", marginLeft: 1 }}>
        <Grid item xs={3}>
          <Autocomplete
            disableClearable
            options={saleFormConfig}
            getOptionLabel={(option) => option.label}
            value={saleFormConfig.find((item) => item.saletype == input.saletype && item.loadingtype == input.loadingtype && item.sourcing == input.sourcing)}
            onChange={(e, newValue) =>
              setInput((prev) => ({ ...prev, saletype: newValue.saletype, loadingtype: newValue.loadingtype, sourcing: newValue.sourcing, saleorder: null, airline: null, airline_name: "" }))
            }
            renderInput={(params) => <TextField {...params} label={t("Loại chứng từ")} />}
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            getDataFunc={() => getInvoiceForm({ status: 1 })}
            value={input.form}
            getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, form: newValue }))}
            label={t("Mẫu số hóa đơn")}
            triggerSetDefaultFunc={Boolean(location.state)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, form: option.find((item) => item.form === location.state.form_no && item.series === location.state.serial) }))}
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            label={t("Khách hàng trực tiếp/Đại lý")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == location.state.customer_id) }))}
            triggerSetDefaultFunc={isReplace}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.customer}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue, acsreg: null, saleorder: null, airline: null, airline_name: "" }))}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomDatePicker
            format="DD/MM/YYYY"
            label={t("Ngày ghi nhận hóa đơn")}
            value={input.date}
            onChange={(value) => setInput((prev) => ({ ...prev, date: value, saleorder: null, airline: null, airline_name: "" }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            label={t("Kho xuất")}
            getDataFunc={() => getInventory({ status: 1, organization_id: user?.organization_id })}
            triggerGetDataFunc={Boolean(user)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, inventory: option.find((item) => item.id === location.state.inventory_id) }))}
            triggerSetDefaultFunc={Boolean(isReplace)}
            value={input.inventory}
            filter={(option) => option.whtype === "2" || option.whtype === "3"}
            onChange={(e, newValue) =>
              setInput((prev) => ({
                ...prev,
                inventory: newValue,
                invoiceproducts: prev.invoiceproducts.map((item) => ({ ...item, vehicle: null, position_no: "" })),
                saleorder: null,
                airline: null,
                airline_name: "",
              }))
            }
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            getDataFunc={() =>
              checkSaleOrder({
                customer_id: input.customer.id,
                invoice_type: 1,
                saletype: input.saletype,
                loadingtype: input.loadingtype,
                valid_date: moment(input.date).format("YYYY-MM-DD"),
                inventory_id: input.inventory.id,
                status: 1,
              }).then((res) => {
                if (res.code === 200) {
                  if (!res.data?.length) enqueueSnackbar(`Không có hợp đồng bán cho ngày ${input.date && moment(input.date).format("DD/MM/YYYY")}`, { variant: "warning" });
                } else enqueueSnackbar(res.message);
                return res;
              })
            }
            getDataDependencies={[input.saletype, input.loadingtype, input.inventory, input.customer]}
            disabled={!input.customer || !input.inventory || !input.date}
            triggerGetDataFunc={input.saletype && input.loadingtype && input.customer && input.inventory && input.date}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, saleorder: option.find((item) => item.id == location.state.saleorderpr_id) }))}
            triggerSetDefaultFunc={Boolean(isReplace)}
            value={input.saleorder}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, saleorder: newValue, airline: null, airline_name: "" }))}
            getOptionLabel={(option) => option.so_no + (option.agent_name ? ` - ${option.agent_name}` : "")}
            label="Số đơn hàng"
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            disabled={!shipped_to}
            label={t("Hãng bay")}
            getDataFunc={() => getCustomers({ status: 1 })}
            triggerGetDataFunc={Boolean(shipped_to)}
            filter={(item) => shipped_to?.filter((item_) => item_.company === -1 || item_.company === user.organization_id).find((item_) => item_.receiver === item.id)}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, airline: newValue, airline_name: newValue?.name || "" }))}
            value={input.airline}
            triggerSetDefaultFunc={Boolean(isReplace)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, airline: option.find((item) => item.id == location.state.airline_id) }))}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label={t("Tên hãng bay")}
            InputLabelProps={{ shrink: true }}
            disabled={!Boolean(input.airline?.name === "Adhoc")}
            value={input.airline_name || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, airline_name: e.target.value }))}
          />
        </Grid>
        <Grid item xs={3} style={{ display: "flex" }}>
          <Checkbox title={t("Nhập thủ công")} checked={input.checkbox_nhap_tay_flight} onChange={(e) => setInput((prev) => ({ ...prev, checkbox_nhap_tay_flight: e.target.checked, flight: null }))} />
          {input.checkbox_nhap_tay_flight ? (
            <TextField
              disabled={!input.customer}
              fullWidth
              value={input.flight?.flight_no || ""}
              onChange={(e) => setInput((prev) => ({ ...prev, flight: { flight_no: e.target.value, route: prev.flight?.route } }))}
              label={t("Số chuyến bay")}
            />
          ) : (
            <FilterBy
              label={t("Số chuyến bay")}
              disabled={!input.customer}
              fullWidth
              filter={(item) => (input.airline ? item.customer_id == input.airline.id : input.customer ? item.customer_id == input.customer.id : true)}
              getDataFunc={() => getFlight({ status: 1, organization_id: user?.organization_id })}
              setDefaultFunc={(option) => setInput((prev) => ({ ...prev, flight: option.find((item) => item.id === location.state.flight_id) }))}
              triggerSetDefaultFunc={Boolean(isReplace)}
              triggerGetDataFunc={Boolean(user)}
              value={input.flight}
              getOptionLabel={(option) => `${option.flight_no} ${option.route}` || ""}
              onChange={(e, newValue) => setInput((prev) => ({ ...prev, flight: newValue }))}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={t("Tuyến bay")}
            fullWidth
            value={input.flight?.route || ""}
            disabled={!input.checkbox_nhap_tay_flight}
            onChange={(e) => setInput((prev) => ({ ...prev, flight: { flight_no: prev.flight?.flight_no, route: e.target.value } }))}
          />
        </Grid>
        <Grid item xs={3} style={{ display: "flex" }}>
          <Checkbox title={t("Nhập thủ công")} checked={input.checkbox_nhap_tay_acsreg} onChange={(e) => setInput((prev) => ({ ...prev, checkbox_nhap_tay_acsreg: e.target.checked, acsreg: null }))} />
          {input.checkbox_nhap_tay_acsreg ? (
            <TextField
              disabled={!input.customer}
              fullWidth
              value={input.acsreg?.code || ""}
              onChange={(e) => setInput((prev) => ({ ...prev, acsreg: { code: e.target.value } }))}
              label="Đăng bạ tàu bay"
            />
          ) : (
            <FilterBy
              label="Đăng bạ tàu bay"
              fullWidth
              disabled={!Boolean(input.customer)}
              getDataFunc={() => getAcsreg({ status: 1, customer_id: input.airline ? input.airline.id : input.customer.id })}
              triggerGetDataFunc={Boolean(input.customer || input.airline)}
              getDataDependencies={[input.customer, input.airline]}
              setDefaultFunc={(option) => setInput((prev) => ({ ...prev, acsreg: option.find((item) => item.id == location.state.acsreg_id) }))}
              triggerSetDefaultFunc={Boolean(isReplace)}
              value={input.acsreg}
              onChange={(e, newValue) => setInput((prev) => ({ ...prev, acsreg: newValue }))}
              getOptionLabel={(option) => `${option.id} - ${option.code}`}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            label={t("Chủng máy bay")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, aircraft: option.find((item) => item.id === location.state.aircraft_id) }))}
            triggerSetDefaultFunc={Boolean(isReplace)}
            getDataFunc={() => getAircraft({ status: 1 })}
            value={input.aircraft}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, aircraft: newValue }))}
          />
        </Grid>
        {input.inventory?.whtype !== "3" && (
          <>
            <Grid item xs={3}>
              <TextField
                label={t("Lượng nạp")}
                fullWidth
                value={input.invoiceproducts[0].meter_after_pump - input.invoiceproducts[0].meter_before_pump}
                // onChange={e => setInput(prev => ({ ...prev, loadsample: e.target.value }))}
                disabled
              />
            </Grid>
            <Grid item xs={3}>
              <TextField label={t("Lưu lượng")} fullWidth value={input.maxflow || ""} onChange={(e) => setInput((prev) => ({ ...prev, maxflow: e.target.value }))} />
            </Grid>
            <Grid item xs={3}>
              <TextField label={t("Chênh áp")} fullWidth value={input.diffpres || ""} onChange={(e) => setInput((prev) => ({ ...prev, diffpres: e.target.value }))} />
            </Grid>
            <Grid item xs={3}>
              <TextField label={t("Áp suất đầu vòi")} fullWidth value={input.nozzlepres || ""} onChange={(e) => setInput((prev) => ({ ...prev, nozzlepres: e.target.value }))} />
            </Grid>
          </>
        )}
        <Grid item xs={3}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm:ss"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Giờ bắt đầu")}
            value={input.start_date}
            onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm:ss"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Giờ kết thúc")}
            value={input.end_date}
            onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            label={t("Tên hàng hóa")}
            getDataFunc={() => getProduct({ status: 1 })}
            triggerSetDefaultFunc={true}
            setDefaultFunc={(option) =>
              setInput((prev) => ({ ...prev, product: option.find((item) => (isReplace ? item.id === location.state.invoiceproducts[0].product_id : item.id === 455496)) || null }))
            }
            value={input.product}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, product: newValue }))}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField label={t("Người điều khiển")} fullWidth value={input.driver || ""} onChange={(e) => setInput((prev) => ({ ...prev, driver: e.target.value }))} />
        </Grid>
        <Grid item xs={3}>
          <TextField label={t("Chứng chỉ số")} fullWidth value={input.cert_no || ""} onChange={(e) => setInput((prev) => ({ ...prev, cert_no: e.target.value }))} />
        </Grid>
        <Grid item xs={3}>
          <TextField label={t("Ghi chú")} fullWidth value={input.note || ""} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
        <Grid item xs={3}>
          <FileInput label={t("Ảnh")} fullWidth accept="image/*" value={input.image} onChange={(file) => setInput((prev) => ({ ...prev, image: file }))} />
        </Grid>
      </Grid>
      <ProductTable input={input} setInput={setInput} />
      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ margin: 5 }}>
          <Button variant="contained" onClick={() => setDialogOpen(true)} color="info">
            {t("Xem trước")}
          </Button>
          <ButtonWithAPICall disabled={!price} variant="contained" api={handleSubmit} response={handleSubmitResponse}>
            {t(location.state ? "Phát hành thay thế" : "Tạo hóa đơn")}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
      <Dialog maxWidth={false} fullWidth={true} scroll="body" onClose={() => setDialogOpen(false)} open={isDialogOpen}>
        <InvoicePreview data={dataForPreview} />
      </Dialog>
    </Paper>
  );
};

export default CreateInvoice;

const ProductTable = ({ input, setInput }) => {
  const [t] = useTranslation();
  const productRef = useRef();
  const location = useLocation();
  //redux state
  const user = useSelector((state) => state.user.data);

  useEffect(() => {
    input.invoiceproducts.forEach((item, index) => {
      handleChangeReceiptProduct(index, "temp", item.temp);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.method]);

  useEffect(() => {
    productRef.current = input.invoiceproducts;
  }, [input.invoiceproducts]);
  const handleChangeReceiptProduct = (index, keyName, value) => {
    let newProduct = [...input.invoiceproducts];
    newProduct[index][keyName] = value;
    if (["temp", "density", "unit", "meter_before_pump", "meter_after_pump"].includes(keyName)) {
      newProduct[index] = {
        ...newProduct[index],
        lit: "",
        d15: "",
        vcf: "",
        wcf: "",
        l15: "",
        kg: "",
        gallon: "",
      };
      switch (keyName) {
        case "temp":
          newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "Temp must be in range 4.5 - 52" : undefined;
          break;
        case "density":
          newProduct[index].density_error = newProduct[index].density < 7000 || newProduct[index].density > 8730 ? "Density must be in range 7000 - 8730" : undefined;
          break;
        default:
          break;
      }
      // kiem tra dieu kien, neu thoa man thi goi api convert
      if (
        newProduct[index].meter_after_pump.toString() &&
        newProduct[index].meter_before_pump.toString() &&
        newProduct[index].unit &&
        newProduct[index].temp &&
        newProduct[index].density &&
        !newProduct[index].temp_error &&
        !newProduct[index].density_error
      ) {
        let { meter_before_pump, meter_after_pump, unit, temp, density } = newProduct[index];
        newProduct[index].loadingState = true;
        postConversion({
          quantity: meter_after_pump - meter_before_pump,
          unit: unit.id,
          temp: temp,
          density: density / 10000,
          method: input.method,
        }).then((res) => {
          if (
            // kiem tra xem du lieu cu co giong du lieu hien tai khong, neu khong giong thi k update
            res.code === 200 &&
            meter_before_pump === productRef.current[index].meter_before_pump &&
            meter_after_pump === productRef.current[index].meter_after_pump &&
            unit === productRef.current[index].unit &&
            temp === productRef.current[index].temp &&
            density === productRef.current[index].density
          ) {
            newProduct = productRef.current;
            newProduct[index] = {
              ...newProduct[index],
              lit: res.data.lit,
              d15: res.data.d15,
              vcf: res.data.vcf,
              wcf: res.data.wcf,
              l15: res.data.l15,
              kg: res.data.kg,
              gallon: res.data.gallon,
              loadingState: undefined,
            };
            setInput((prev) => ({ ...prev, invoiceproducts: newProduct }));
          }
        });
      }
    }
    setInput((prev) => ({ ...prev, invoiceproducts: newProduct }));
  };
  return (
    <>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>{t("Thông tin hàng hóa")}</div>
      <div align="left" style={{ display: "flex", alignItems: "center" }}>
        <ButtonGroup>
          <Button onClick={() => input.method !== 1 && setInput((prev) => ({ ...prev, method: 1 }))} style={{ backgroundColor: input.method === 1 ? "lightblue" : "" }}>
            KG = L15 * WCF
          </Button>
          <Button onClick={() => input.method !== 2 && setInput((prev) => ({ ...prev, method: 2 }))} style={{ backgroundColor: input.method === 2 ? "lightblue" : "" }}>
            KG = LTT * DENSITY
          </Button>
        </ButtonGroup>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">Xe tra nạp số</TableCell>
              <TableCell align="center">*Vị trí tra nạp</TableCell>
              <TableCell align="center">*Số công tơ đầu</TableCell>
              <TableCell align="center">*Số công tơ cuối</TableCell>
              <TableCell align="center">Khối lượng</TableCell>
              <TableCell align="center">Đơn vị</TableCell>
              <TableCell align="center">°C</TableCell>
              <TableCell align="center">*{t("Tỷ trọng")}</TableCell>
              <TableCell align="center">D15</TableCell>
              <TableCell align="center">VCF</TableCell>
              <TableCell align="center">WCF</TableCell>
              <TableCell align="center">
                {t("Số lượng")} ({t("lit")} 15℃)
              </TableCell>
              <TableCell align="center">{t("Số lượng")} (kg)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {input.invoiceproducts?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <FilterBy
                    getDataFunc={() => getVehicle({ status: 1, organization_id: user?.organization_id, end_date: moment(Date.now()).format("YYYY-MM-DD") })}
                    getDataDependencies={[input.inventory, user]}
                    triggerGetDataFunc={Boolean(input.inventory && user)}
                    setDefaultFunc={(option) =>
                      handleChangeReceiptProduct(
                        0,
                        "vehicle",
                        option.find((item) => item.license_plate === location.state.invoiceproducts[0].refueler_no)
                      )
                    }
                    triggerSetDefaultFunc={Boolean(location.state)}
                    value={item.vehicle}
                    sx={{ width: "200px" }}
                    filter={(item) =>
                      item.groupvehicle_type === input.loadingtype &&
                      ((item.groupvehicle_code === "00" && input.inventory?.whtype === "2") || (item.groupvehicle_code === "01" && input.inventory?.whtype == "3"))
                    }
                    disabled={!input.inventory}
                    getOptionLabel={(option) => option.license_plate || ""}
                    onChange={(e, newValue) => handleChangeReceiptProduct(index, "vehicle", newValue)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    InputProps={{ style: { width: 200 } }}
                    value={item.position_no || ""}
                    disabled={!input.inventory || input.inventory?.whtype != 3}
                    onChange={(e) => handleChangeReceiptProduct(index, "position_no", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    type="number"
                    InputProps={{ style: { width: 150 } }}
                    onChange={(e) => e.target.value >= 0 && handleChangeReceiptProduct(index, "meter_before_pump", e.target.value)}
                    value={item.meter_before_pump || ""}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    type="number"
                    InputProps={{ style: { width: 150 } }}
                    value={item.meter_after_pump || ""}
                    onChange={(e) => e.target.value >= 0 && handleChangeReceiptProduct(index, "meter_after_pump", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField fullWidth InputProps={{ style: { width: 150 } }} disabled value={Math.round(item.meter_after_pump - item.meter_before_pump)?.toLocaleString()} />
                </TableCell>
                <TableCell align="center">
                  <FilterBy
                    getDataFunc={() => getProductUnit({ status: 1 })}
                    value={item.unit}
                    triggerSetDefaultFunc={true}
                    setDefaultFunc={(_, option) =>
                      handleChangeReceiptProduct(
                        index,
                        "unit",
                        option.find((item) => item.id === (location.state ? location.state.invoiceproducts[0].productunit_id : 22))
                      )
                    }
                    onChange={(e, newValue) => handleChangeReceiptProduct(index, "unit", newValue)}
                    filter={(option) => [21, 22].includes(option.id)}
                    style={{ width: 100 }}
                    getOptionLabel={(option) => option.name || ""}
                    label={t("Đơn vị tính")}
                    disableClearable
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    inputProps={{ style: { textAlign: "center", width: 50 } }}
                    value={item.temp || ""}
                    error={(item.temp < 4.5 || item.temp > 52) && item.temp !== ""}
                    helperText={item.temp < 4.5 || item.temp > 52 ? "(4-52)" : " "}
                    style={{ paddingTop: 20 }}
                    onChange={(e) => handleChangeReceiptProduct(index, "temp", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    inputProps={{ style: { textAlign: "center", width: 75 } }}
                    value={item.density || ""}
                    error={(item.density < 7001 || item.density > 8730) && item.density !== ""}
                    helperText={item.density < 7001 || item.density > 8730 ? "(7001-8730)" : " "}
                    style={{ paddingTop: 20 }}
                    onChange={(e) => handleChangeReceiptProduct(index, "density", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                <TableCell align="center">{item.vcf && parseFloat(item.vcf)?.toFixed(4)}</TableCell>
                <TableCell align="center">{item.wcf && parseFloat(item.wcf)?.toFixed(4)}</TableCell>
                <TableCell align="center">{Math.round(item.l15)?.toLocaleString()}</TableCell>
                <TableCell align="center">{Math.round(item.kg)?.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
